import { Tab, withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    textTransform: 'none',
  },
})(Tab);
